/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_In_Reason_From_PurchaseInputs */

const vi_pl_in_reason_from_purchase = /** @type {(inputs: Pl_In_Reason_From_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ đơn mua`)
};

/**

* @param {Pl_In_Reason_From_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_in_reason_from_purchase = /** @type {((inputs?: Pl_In_Reason_From_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_In_Reason_From_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_in_reason_from_purchase(inputs)
});